import { Text } from '@mantine/core';
import { DateChip } from '@ayocore/platform/client/components/elements';
import { ViewPanel, InfoRow } from '@ayocore/platform/client/components/EntityViewLayout';
import type { DealExtended } from '../DealViewController';

interface DealDatesProps {
  deal: DealExtended;
  canEdit?: boolean;
  /** Право редактировать `close_date_fact` (только CRM_OWNER в grasias). */
  canEditCloseDate?: boolean;
  onDeliveryDatePlanSave?: (date: Date | null) => void | Promise<void>;
  onCloseDateFactSave?: (date: Date | null) => void | Promise<void>;
}

const LABEL_WIDTH = 260;

/**
 * Блок дат сделки: плановая (редактируемая, по `canEdit`) и фактическая
 * (редактируемая отдельным правом `canEditCloseDate`).
 */
export function DealDates({
  deal,
  canEdit = false,
  canEditCloseDate = false,
  onDeliveryDatePlanSave,
  onCloseDateFactSave,
}: DealDatesProps) {
  return (
    <ViewPanel>
      <InfoRow>
        <InfoRow.TitleCol width={LABEL_WIDTH}>Плановая дата закрытия</InfoRow.TitleCol>
        <InfoRow.ValueCol>
          {canEdit && onDeliveryDatePlanSave ? (
            <DateChip
              value={deal.delivery_date_plan}
              label='Указать'
              color='blue'
              onSave={date => void onDeliveryDatePlanSave(date)}
            />
          ) : (
            <Text size='xs'>
              {deal.delivery_date_plan
                ? new Date(deal.delivery_date_plan).toLocaleDateString('ru-RU')
                : 'Не указана'}
            </Text>
          )}
        </InfoRow.ValueCol>
      </InfoRow>
      <InfoRow>
        <InfoRow.TitleCol width={LABEL_WIDTH}>Фактическая дата оплаты и отгрузки</InfoRow.TitleCol>
        <InfoRow.ValueCol>
          {canEditCloseDate && onCloseDateFactSave ? (
            <DateChip
              value={deal.close_date_fact}
              label='Указать'
              color='blue'
              onSave={date => void onCloseDateFactSave(date)}
            />
          ) : (
            <Text size='xs' c={deal.close_date_fact ? undefined : 'dimmed'}>
              {deal.close_date_fact
                ? new Date(deal.close_date_fact).toLocaleDateString('ru-RU')
                : 'Ожидает оплаты и отгрузки'}
            </Text>
          )}
        </InfoRow.ValueCol>
      </InfoRow>
    </ViewPanel>
  );
}
